import { lazy } from "react";

export const MainAsync = lazy(()=>import("./MainPage"))